import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { isSystemBucket } from '../services/bucket.service';
import { DataSource } from '../services/data-sources.service';

/**
 * Display name of a knowledge source in agent link pickers. Customer folders
 * keep their own name; an internal `__dozent_knowledge__` folder (one per
 * lecturer) reads „Dozenten-Dateien · <Name>" instead of the raw folder name
 * (#230, rule in `isSystemBucket`). Use with `| async`.
 */
@Pipe({
  name: 'knowledgeSourceName',
})
export class KnowledgeSourceNamePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    source: Pick<DataSource, 'name' | 'owner_name'> | null | undefined
  ): Observable<string> {
    if (!source) return of('');
    if (!isSystemBucket(source)) return of(source.name);
    return source.owner_name
      ? this.translate.stream('pages.tutors.knowledgeBase.dozentFilesOf', {
          name: source.owner_name,
        })
      : this.translate.stream('pages.tutors.knowledgeBase.dozentFiles');
  }
}
